import { Button, Fade, MenuItem, Popover } from '@material-ui/core';
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkIcon from '@material-ui/icons/Link';
import RedditIcon from '@material-ui/icons/Reddit';
import ShareIcon from '@material-ui/icons/Share';
import TwitterIcon from '@material-ui/icons/Twitter';
import * as React from 'react';
import toast, { Toaster } from 'react-hot-toast';

import { useAuth } from '../../../auth';
import style from './socialShareDropdown.module.css';

export interface SocialProps {
  url: string;
  styles: string;
  buttonStyle: {};
}

export const SocialShareDropdown: React.FC<SocialProps> = props => {
  const { authenticated } = useAuth();
  const { styles, buttonStyle } = props;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  let link;
  const ahref = window.location.href;
  const encodedAhref = encodeURIComponent(ahref);

  const twitterText = encodeURIComponent('Check out this NFT @ ');

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (social: string) => {
    if (social === 'Twitter') {
      link = `https://twitter.com/intent/tweet?url=${encodedAhref}&text=${twitterText}`;
      window.open(link, '_blank');
    } else if (social === 'Facebook') {
      link = `https://www.facebook.com/sharer/sharer.php?u=${encodedAhref}&amp;src=sdkpreparse`;
      window.open(link, '_blank');
    } else if (social === 'Reddit') {
      link = `https://www.reddit.com/submit?url=${encodedAhref}`;
      window.open(link, '_blank');
    } else if (social === 'Clipboard') {
      void window.navigator.clipboard.writeText(ahref);
      toast.success('Link copied to clipboard!');
    }
    setAnchorEl(null);
  };

  return (
    <div className={styles}>
      <Toaster />
      <Button
        id="fade-button"
        aria-controls="fade-menu"
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        className={styles + ' justify-center items-center'}
        style={buttonStyle}
      >
        <ShareIcon className="mr-2" />
        <div className="2xl:text-lg lg:text-base text-sm">Share</div>
      </Button>
      <Popover
        id="fade-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
        PaperProps={{
          style: {
            color: 'white',
            backgroundColor: '#3b3f58',
            position: 'absolute',
          },
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        disableScrollLock={true}
        elevation={1}
        classes={
          authenticated
            ? { paper: `${style.drawerLoggedIn}` }
            : { paper: `${style.drawer}` }
        }
      >
        <MenuItem
          onClick={() => handleClose('Twitter')}
          className={`${style.mobile}`}
        >
          <TwitterIcon className="mr-2" />
          Twitter
        </MenuItem>
        <MenuItem
          onClick={() => handleClose('Facebook')}
          className={`${style.mobile}`}
        >
          <FacebookIcon className="mr-2" />
          Facebook
        </MenuItem>
        <MenuItem
          onClick={() => handleClose('Reddit')}
          className={`${style.mobile}`}
        >
          <RedditIcon className="mr-2" />
          Reddit
        </MenuItem>
        <MenuItem
          onClick={() => handleClose('Clipboard')}
          className={`${style.mobile}`}
        >
          <LinkIcon className="mr-2" />
          Copy Link
        </MenuItem>
      </Popover>
    </div>
  );
};
